import React, { FC, useMemo } from 'react';
import { time } from 'uniqid';
import { get, map, findIndex } from 'lodash';
import { interpolateTemplate } from '@trip-ux/common'

export interface ListItemProps {
  label: string;
  complete: string;
  current: string;
  isActive: boolean;
  isVisited: boolean;
  id?: string;
}
export interface StepperProps {
  listItems: {
    id?: string;
    label: string;
  }[];
  id?: string;
  complete: string;
  current: string;
  stepLabel: string;
  activeStep: string;
  className?: string;
}

export const ListItem: FC<ListItemProps> = ({
  label,
  current,
  complete,
  isActive,
  isVisited,
  id = time('stepper-item-')
}) => {
  let alabel = '';
  if (isActive) {
    alabel = current;
  } else if (isVisited) {
    alabel = complete;
  }
  return (
    <li
      className={`${isActive ? 'active' : ''} ${isVisited ? 'visited' : ''} p-0`}
      tabIndex={isActive || isVisited ? 0 : -1}
      id={id}
      data-testid={id}>
      <span className="d-none d-md-block w-100">{`${label}${alabel}`}</span>
    </li>
  );
};

export const Stepper: FC<StepperProps> = ({
  id = time('stepper-'),
  stepLabel,
  complete,
  current,
  activeStep,
  listItems,
  className = ''
}) => {
  const activeIndex = useMemo(() => {
    const index = findIndex(listItems, { label: activeStep });
    return index && index === -1 ? 0 : index;
  }, [activeStep, listItems]);
  const activeLabel = get(listItems, `[${activeIndex}].label`);
  const renderedLabel = stepLabel ? interpolateTemplate(stepLabel, { active: activeIndex + 1, total: listItems.length }) : '';
  return (
    <div className={`stepper w-100 ${className}`} id={id}>
      <p className="mx-auto">
  {stepLabel && renderedLabel}
        <span className="sr-only">{activeLabel}</span>
      </p>
      <ul className="p-0 m-0">
        {map(listItems, (item, idx) => (
          <ListItem
            label={item.label}
            complete={complete}
            current={current}
            id={item.id}
            key={time(`${idx}-`)}
            isActive={activeIndex === idx}
            isVisited={idx < activeIndex}
          />
        ))}
      </ul>
      <p className="d-md-none text-center my-3 stepper-label" aria-hidden="true">
        {activeLabel}
      </p>
    </div>
  );
};

Stepper.displayName = 'Stepper';
export default Stepper;
